export const SAVE_USER_INFO = Symbol();
export const SAVE_LOGIN_INFO = Symbol();
export const GET_USER_INFO = Symbol();
export const ASYNC_SAVE_USER_INFO = Symbol();
export const SAVE_HOME_INFO = Symbol();
export const ASYNC_SAVE_HOME_INFO = Symbol();
export const GET_HOME_INFO = Symbol();
export const SAVE_CAMPAIGN_AD_POS = Symbol();

//user
export const UPDATE_USER_INFO = Symbol();